module.exports = __webpack_public_path__ + "static/media/linkedin.cfaf9839.svg";